function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M388.749,47.038c-0.886-0.036-1.773-0.042-2.66-0.017h-33.437V18.286C352.653,6.792,341.681,0,330.187,0h-30.824 c-11.494,0-19.853,6.792-19.853,18.286V47.02H154.122V18.286C154.122,6.792,145.763,0,134.269,0h-30.825 C91.951,0,80.979,6.792,80.979,18.286V47.02H47.543C26.199,46.425,8.414,63.246,7.819,84.589 c-0.025,0.886-0.019,1.774,0.017,2.66v301.975c0,22.988,16.718,44.408,39.706,44.408H386.09c22.988,0,39.706-21.42,39.706-44.408 V87.249C426.67,65.915,410.083,47.912,388.749,47.038z M299.363,20.898h32.392v57.469h-32.392V20.898z M103.445,20.898h29.78 v57.469h-29.78V20.898z M404.898,389.224c0,11.494-7.314,23.51-18.808,23.51H47.543c-11.494,0-18.808-12.016-18.808-23.51 V167.184h376.163V389.224z M404.898,87.249v59.037H28.734V87.249c-0.885-9.77,6.318-18.408,16.088-19.293 c0.904-0.082,1.814-0.094,2.72-0.037h33.437v11.494c0,11.494,10.971,19.853,22.465,19.853h30.825 c10.672,0.293,19.56-8.122,19.853-18.794c0.01-0.353,0.01-0.706,0-1.059V67.918H279.51v11.494 c-0.293,10.672,8.122,19.56,18.794,19.853c0.353,0.01,0.706,0.01,1.059,0h30.825c11.494,0,22.465-8.359,22.465-19.853V67.918 h33.437c9.791-0.617,18.228,6.82,18.845,16.611C404.992,85.435,404.98,86.345,404.898,87.249z"
}), React.createElement("path", {
  d: "M158.824,309.812l-9.404,52.245c-0.372,2.241-0.004,4.543,1.049,6.556c2.675,5.113,8.989,7.09,14.102,4.415l47.02-24.555 l47.02,24.555l4.702,1.045c2.267,0.04,4.48-0.698,6.269-2.09c3.123-2.281,4.73-6.099,4.18-9.927l-9.404-52.245l38.139-36.571 c2.729-2.949,3.719-7.109,2.612-10.971c-1.407-3.57-4.577-6.145-8.359-6.792l-52.245-7.837l-23.51-47.543 c-1.025-2.116-2.733-3.825-4.849-4.849c-5.194-2.515-11.443-0.344-13.959,4.849l-23.51,47.543l-52.245,7.837 c-3.782,0.646-6.952,3.222-8.359,6.792c-1.107,3.862-0.116,8.022,2.612,10.971L158.824,309.812z M187.559,267.494 c3.281-0.491,6.061-2.675,7.314-5.747l16.718-33.437l16.718,33.437c1.254,3.072,4.033,5.256,7.314,5.747l37.094,5.224 l-26.645,25.6c-2.482,2.457-3.646,5.949-3.135,9.404l6.269,37.094l-32.914-17.763l-4.702-1.045l-4.702,1.045l-32.914,17.763 l6.269-37.094c0.512-3.455-0.653-6.947-3.135-9.404l-26.645-25.6L187.559,267.494z"
}))));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgEvent = function SvgEvent(props) {
  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 433.633 433.633",
    style: {
      enableBackground: "new 0 0 433.633 433.633"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

export default __webpack_public_path__ + "static/media/event.f2fd9d65.svg";
export { SvgEvent as ReactComponent };